export const BRAND_ASSETS = {
  appIcon: {
    dark512: "/ui/brand-kit/app-icons/chickytutor-app-icon-dark-512.png",
    dark1024: "/ui/brand-kit/app-icons/chickytutor-app-icon-dark-1024.png",
    light512: "/ui/brand-kit/app-icons/chickytutor-app-icon-light-512.png",
    light1024: "/ui/brand-kit/app-icons/chickytutor-app-icon-light-1024.png",
  },
  lockup: {
    dark: "/ui/brand-kit/lockups/chickytutor-lockup-horizontal-dark-1080.png",
    light: "/ui/brand-kit/lockups/chickytutor-lockup-horizontal-light-1080.png",
  },
  mark: {
    png: "/ui/brand-kit/marks/chickytutor-face-mark-512.png",
    web: "/ui/brand-kit/web/chickytutor-face-mark-512.webp",
  },
  mascot: {
    signature: "/ui/brand-kit/web/chickytutor-mascot-signature.webp",
    teaching: "/ui/brand-kit/web/chickytutor-mascot-teaching.webp",
  },
} as const;
